/** Username rules (spec §2.1): 1–20 chars after trimming, no control/invisible characters. */
export const NAME_MAX = 20;

const UNSAFE_TEXT =
  // eslint-disable-next-line no-control-regex
  /[\u0000-\u001f\u007f-\u009f\u200b\u200e\u200f\u202a-\u202e\u2066-\u2069\ufeff]/;

export type NameProblem = 'required' | 'tooLong' | 'invalid';

export function cleanName(raw: string): string {
  return raw.trim().normalize('NFC');
}

export function nameProblem(raw: string): NameProblem | null {
  const name = cleanName(raw);
  if (name.length === 0) return 'required';
  if (name.length > NAME_MAX) return 'tooLong';
  if (UNSAFE_TEXT.test(name)) return 'invalid';
  return null;
}
